
import createIconComponent from './utils/createIconComponent';
import React from 'react';
var IconArrowCircleLeft = createIconComponent({ fillContent: React.createElement(
    'g',
    null,
    React.createElement('path', { d: 'M12 0a12 12 0 1012 12A12.013 12.013 0 0012 0zm3.906 17.008a1.25 1.25 0 11-1.521 1.984l-7.346-5.634a1.711 1.711 0 010-2.716l7.346-5.634a1.25 1.25 0 111.521 1.984L9.635 11.8a.249.249 0 000 .4z' })
  ), lightContent: React.createElement(
    'g',
    null,
    React.createElement('path', { d: 'M15.499 19.001a.496.496 0 01-.303-.102l-7.981-6.101a.994.994 0 01-.384-.926.99.99 0 01.383-.662l7.981-6.107a.503.503 0 01.702.093.499.499 0 01-.094.701l-7.981 6.107 7.98 6.099a.501.501 0 01-.303.898z' }),
    React.createElement('path', { d: 'M12 24C5.383 24 0 18.617 0 12S5.383 0 12 0s12 5.383 12 12-5.383 12-12 12zm0-23C5.935 1 1 5.935 1 12s4.935 11 11 11 11-4.935 11-11S18.065 1 12 1z' })
  ), regularContent: React.createElement(
    'g',
    null,
    React.createElement('path', { d: 'M12 24C5.383 24 0 18.617 0 12S5.383 0 12 0s12 5.383 12 12-5.383 12-12 12zm0-22.5C6.21 1.5 1.5 6.21 1.5 12S6.21 22.5 12 22.5 22.5 17.79 22.5 12 17.79 1.5 12 1.5z' }),
    React.createElement('path', { d: 'M15 18a.757.757 0 01-.403-.117l-7.256-4.617a1.53 1.53 0 01-.459-.458 1.486 1.486 0 01-.2-1.131c.086-.391.32-.726.658-.942l7.257-4.618a.748.748 0 011.036.23.751.751 0 01-.23 1.036L8.147 12l7.256 4.617A.75.75 0 0115 18z' })
  ), height: undefined, width: undefined, viewBox: "0 0 24 24" });
IconArrowCircleLeft.displayName = 'IconArrowCircleLeft';
export default IconArrowCircleLeft;